module.exports = __webpack_public_path__ + "img/close.8cda280d.svg";